import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from '../../img/image_2024_04_30T07_32_45_647Z.png';
import LogoTSP from '../../img/LOGO_TSP_BLANCO.png';
import { IoSchoolOutline } from "react-icons/io5";
import { HiOutlineAcademicCap } from "react-icons/hi2";
import UserMenu from "./UserMenu";
import CustomTooltip from "../eventos/avisos/Tooltip";
import { MenuConvocatoria, MenuBonificada, MenuPersonas, MenuWiki, MenuInventario, MenuVacaciones, MenuComunicacion,  MenuEstadisticas, MenuConfiguracion, MenuGestorIntervenciones } from "./SubSiderbar";
import { GrUserWorker } from "react-icons/gr";
import Hamburger from 'hamburger-react';
import { LuBookText } from "react-icons/lu";
import { FaBox, FaUmbrellaBeach, FaNewspaper, FaBoxesStacked } from "react-icons/fa6";
import { FaCog } from "react-icons/fa";
import { BsGraphUp } from "react-icons/bs";
import { UsuarioContext } from '../../providers/personaContext';
import InventarioSidebar from '../../componentes/inventario/InventarioSidebar';
import FormacionSidebar from '../../componentes/laeformacion/FormacionSidebar';
import SoporteSidebar from '../../componentes/soporte/SoporteSidebar';
import { OCULTAR_FORMACION, OCULTAR_SOPORTE } from '../../../config/flags';
import useIntervencionesDisponibilidad from '../../componentes/intervenciones/hooks/useIntervencionesDisponibilidad';
import { MdOutlineSettingsRemote } from "react-icons/md";
import { FiLifeBuoy } from "react-icons/fi";
import { LuGraduationCap } from 'react-icons/lu';

// Convocatoria = sistema SEPE legacy. Retirado del sidebar el 2026-07-27.
// Las rutas /convocatoria/* siguen vivas por URL directa (retirada gradual).
// Para reactivar en el sidebar, cambiar a true.
const MOSTRAR_CONVOCATORIA = false;

const Sidebar = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [numbtn, setNumbtn] = useState(parseInt(localStorage.getItem("numActivo") || "0"));

  const persona = useContext(UsuarioContext);
  const rol = persona.persona?.rol || "General";
  const tieneAccesoReservas = persona.persona?.reservas || false;
  const esSupervisor = persona.persona?.es_supervisor || false;

  const permisos = persona.permisos || [];
  const tienePermiso = (clave) => permisos.includes(clave);

  // Eje participación de Citas Técnicas (reutiliza GET /mi-disponibilidad).
  // Durante loading devuelve ambos true (anti-parpadeo); ver hook.
  const { esUsuarioActivo, esTecnicoActivo } = useIntervencionesDisponibilidad();

  const adminMenus = [
    { id: 0, name: "Convocatoria", icon: IoSchoolOutline },
    { id: 2, name: "Personas", icon: GrUserWorker },
    { id: 3, name: "Documentación", icon: LuBookText },
    { id: 4, name: "Utilidades", icon: FaBox },
    { id: 5, name: "Vacaciones", icon: FaUmbrellaBeach },
    { id: 6, name: "Comunicación", icon: FaNewspaper },
    // id 7 (Estadísticas) NO va estático: lo añade abajo el bloque por permiso
    // `ringover`, para que el icono aparezca solo a quien también puede entrar
    // en la ruta (antes se veía para todo admin sin la clave).
    { id: 9, name: "Gestión de Intervenciones Técnicas", icon: MdOutlineSettingsRemote },
    { id: 8, name: "Configuración", icon: FaCog },
  ];

  const menuConfig = {
    Administrador: adminMenus,
    "Super Administrador": adminMenus,
    General: [
      { id: 2, name: "Personas", icon: GrUserWorker },
      { id: 3, name: "Documentación", icon: LuBookText },
      { id: 4, name: "Utilidades", icon: FaBox },
      { id: 5, name: "Vacaciones", icon: FaUmbrellaBeach },
      { id: 9, name: "Mis Citas Técnicas", icon: MdOutlineSettingsRemote },
    ],
    "Gestor de Contenidos": [
      { id: 0, name: "Convocatoria", icon: IoSchoolOutline },
      { id: 2, name: "Personas", icon: GrUserWorker },
      { id: 3, name: "Documentación", icon: LuBookText },
      { id: 4, name: "Utilidades", icon: FaBox },
      { id: 5, name: "Vacaciones", icon: FaUmbrellaBeach },
      { id: 9, name: "Mis Citas Técnicas", icon: MdOutlineSettingsRemote },
    ],
    "Recursos Humanos": [
      { id: 2, name: "Personas", icon: GrUserWorker },
      { id: 3, name: "Documentación", icon: LuBookText },
      { id: 4, name: "Utilidades", icon: FaBox },
      { id: 5, name: "Vacaciones", icon: FaUmbrellaBeach },
      { id: 9, name: "Mis Citas Técnicas", icon: MdOutlineSettingsRemote },
    ],
    default: [
      { id: 0, name: "Convocatoria", icon: IoSchoolOutline },
      { id: 3, name: "Documentación", icon: LuBookText },
      { id: 4, name: "Utilidades", icon: FaBox },
      { id: 5, name: "Vacaciones", icon: FaUmbrellaBeach },
      { id: 9, name: "Mis Citas Técnicas", icon: MdOutlineSettingsRemote },
    ]
  };

  const esColaborador = persona.persona?.es_colaborador || false;
  const esPersonaColaboradora = persona.persona?.es_persona_colaboradora || false;
  const empresaVacaciones = persona.persona?.empresa_vacaciones !== false;

  const negocioLogo = persona.persona?.empresa_logo || null;
  const negocioNombre = persona.persona?.empresa_nombre || '';
  const esTerrassa = negocioNombre.toUpperCase().includes('TERRASSA');
  const usarLogoEmpresa = esColaborador && !!negocioLogo;
  const logoSrc = esTerrassa
    ? LogoTSP
    : usarLogoEmpresa
      ? `${process.env.REACT_APP_API_URL}/api/negocio/logo/${negocioLogo}`
      : Logo;
  const logoStyle = usarLogoEmpresa && !esTerrassa
    ? {}
    : { filter: "brightness(0) invert(1)" };

  const getMenusForRole = () => {
    let menus = menuConfig[rol] || menuConfig.default || [];

    // T2: Convocatoria (id 0, SEPE legacy) oculta del rail salvo que se reactive el flag.
    if (!MOSTRAR_CONVOCATORIA) menus = menus.filter(m => m.id !== 0);

    if (!tieneAccesoReservas && !["Administrador", "Super Administrador"].includes(rol)) {
      menus = menus.filter(menu => menu.id !== 4);
    }

    if (esColaborador) {
      menus = menus.filter(menu => menu.id !== 2 && menu.id !== 3);
    }

    if (esPersonaColaboradora && !empresaVacaciones) {
      menus = menus.filter(menu => menu.id !== 5);
    }

    // Estadísticas: si tiene permiso "ringover" (por rol o individual) y aún no está
    if (tienePermiso('ringover') && !menus.find(m => m.id === 7)) {
      menus = [...menus, { id: 7, name: "Estadísticas", icon: BsGraphUp }];
    }

    // Inventario (módulo nuevo): II.6 Capa 1 — visible si el usuario tiene
    // CUALQUIER permiso fino del módulo (inventario.*). El Super Admin lo
    // mantiene porque GET /api/permisos/mios le devuelve todas las claves
    // activas; aun así se deja explícito como salvaguarda.
    // (Sustituye al CANDADO v1 que lo limitaba a 'Super Administrador'.)
    // Se inserta justo debajo de Vacaciones (id 5).
    const tieneAlgunPermisoInventario =
      rol === 'Super Administrador' || permisos.some(p => p.startsWith('inventario.'));
    if (tieneAlgunPermisoInventario && !menus.find(m => m.id === 10)) {
      const entradaInventario = { id: 10, name: "Inventario", icon: FaBoxesStacked };
      const idxVacaciones = menus.findIndex(m => m.id === 5);
      if (idxVacaciones >= 0) {
        menus = [...menus.slice(0, idxVacaciones + 1), entradaInventario, ...menus.slice(idxVacaciones + 1)];
      } else {
        menus = [...menus, entradaInventario];
      }
    }

    // Formación (LAE): visible si el usuario tiene CUALQUIER permiso fino formacion.*
    const tieneAlgunPermisoFormacion =
      rol === 'Super Administrador' || permisos.some(p => p.startsWith('formacion.'));
    if (!OCULTAR_FORMACION && tieneAlgunPermisoFormacion && !menus.find(m => m.id === 11)) {
      const entradaFormacion = { id: 11, name: "Formación", icon: LuGraduationCap };
      const idxInventario = menus.findIndex(m => m.id === 10);
      const idxRef = idxInventario >= 0 ? idxInventario : menus.findIndex(m => m.id === 5);
      if (idxRef >= 0) menus = [...menus.slice(0, idxRef + 1), entradaFormacion, ...menus.slice(idxRef + 1)];
      else menus = [...menus, entradaFormacion];
    }

    // Soporte: visible para TODOS los autenticados (cualquiera abre Mis tickets /
    // Nuevo ticket). Los items de panel/equipo/áreas se filtran por permiso dentro
    // del sub-sidebar. Se inserta tras Formación (id 11) o, si no, al final antes
    // de Configuración.
    if (!OCULTAR_SOPORTE && !menus.find(m => m.id === 12)) {
      const entradaSoporte = { id: 12, name: "Soporte", icon: FiLifeBuoy };
      const idxFormacion = menus.findIndex(m => m.id === 11);
      const idxRef = idxFormacion >= 0 ? idxFormacion : menus.findIndex(m => m.id === 10);
      if (idxRef >= 0) menus = [...menus.slice(0, idxRef + 1), entradaSoporte, ...menus.slice(idxRef + 1)];
      else menus = [...menus, entradaSoporte];
    }

    // Configuración: solo Super Administrador
    if (rol === 'Super Administrador' && !menus.find(m => m.id === 8)) {
      menus = [...menus, { id: 8, name: "Configuración", icon: FaCog }];
    }

    // Citas Técnicas (id 9): visible por ADMINISTRACIÓN (permisos intervenciones.*)
    // O por PARTICIPACIÓN (es_usuario/tecnico_activo), mismo OR que accesoMisCitas
    // en backend. Se retira la puerta si no cumple ninguno de los dos ejes, y el
    // nombre depende de LO QUE PUEDE HACER, no de su rol.
    const esSuperInterv = rol === 'Super Administrador';
    const hasAdminInterv = esSuperInterv
      || tienePermiso('intervenciones.dashboard.view')
      || tienePermiso('intervenciones.campanas.view')
      || tienePermiso('intervenciones.informes.view')
      || tienePermiso('intervenciones.campanas.manage');
    const hasPersonalInterv = esUsuarioActivo || esTecnicoActivo || tienePermiso('intervenciones.miscitas.view');
    if (hasAdminInterv || hasPersonalInterv) {
      const nombreInterv = hasAdminInterv ? 'Gestión de Intervenciones Técnicas' : 'Mis Citas Técnicas';
      menus = menus.map(m => (m.id === 9 ? { ...m, name: nombreInterv } : m));
    } else {
      menus = menus.filter(m => m.id !== 9);
    }

    // Configuración (id 8): módulo Super-Admin por diseño (el submenú tiene
    // items solo para Super Administrador; ruta permisos SA-only). El icono
    // llegaba desde adminMenus compartido con Administrador → engranaje huérfano.
    // Se retira salvo Super Admin, mismo criterio derivado que id 9.
    if (rol !== 'Super Administrador') {
      menus = menus.filter(m => m.id !== 8);
    }

    // T3: Formación (id 11) al primer puesto del rail, preservando el orden del resto.
    // Se hace al final para no descolocar Soporte (id 12), que se ancla a Formación.
    const formacion = menus.find(m => m.id === 11);
    if (formacion) menus = [formacion, ...menus.filter(m => m.id !== 11)];

    // Configuración (id 8) SIEMPRE al final del rail (patrón "ajustes abajo",
    // separado de los módulos de trabajo). Debe ser la ÚLTIMA transformación
    // para que ningún insert dinámico (Estadísticas, etc.) quede por debajo.
    const configuracion = menus.find(m => m.id === 8);
    if (configuracion) menus = [...menus.filter(m => m.id !== 8), configuracion];

    return menus;
  };

  const getMenuFromPath = (pathname) => {
    if (pathname.startsWith('/convocatoria')) return 0;
    if (pathname.startsWith('/gestionpersonas')) return 2;
    if (pathname.startsWith('/documentos')) return 3;
    if (pathname === '/utilidades') return 4;
    if (pathname.startsWith('/inventario')) return 10;
    if (pathname.startsWith('/formacion')) return 11;
    if (pathname.startsWith('/panel/vacaciones')) return 5;
    if (pathname.startsWith('/comunicacion')) return 6;
    if (pathname.startsWith('/estadisticas')) return 7;
    if (pathname.startsWith('/configuracion')) return 8;
    if (pathname.startsWith('/citas-tecnicas') || pathname.startsWith('/gestionintervenciones')) return 9;
    if (pathname.startsWith('/soporte')) return 12;
    return parseInt(localStorage.getItem("numActivo") || "0");
  };

  const handleChange = (num) => {
    setNumbtn(num);
    localStorage.setItem("numActivo", num);
  };

  useEffect(() => {
    const menuFromPath = getMenuFromPath(location.pathname);
    const menusDisponibles = getMenusForRole().map(menu => menu.id);

    if (menusDisponibles.includes(menuFromPath) && menuFromPath !== numbtn) {
      handleChange(menuFromPath);
    }
  }, [location.pathname]);

  useEffect(() => {
    const idTimeout = setTimeout(() => {
      if (rol) {
        const menusDisponibles = getMenusForRole().map(menu => menu.id);
        if (!menusDisponibles.includes(numbtn)) {
          handleChange(menusDisponibles[0]);
        }
      }
    }, 500);

    return () => clearTimeout(idTimeout);
  }, [rol, numbtn]);

  const sidebarClass = props.convocatoria ? "sidebar convocatoria-active" : "sidebar";

  // Rail: los módulos arriba y Configuración (id 8) anclada ABAJO como apartado
  // (patrón "ajustes abajo"). El anclaje real lo hace el CSS (.lista-config →
  // margin-top:auto); aquí solo separamos el item.
  const menusRol = getMenusForRole();
  const menusArriba = menusRol.filter((m) => m.id !== 8);
  const itemConfig = menusRol.find((m) => m.id === 8);
  const renderRailItem = (menu) => (
    <li
      key={menu.id}
      onClick={() => {
        handleChange(menu.id);
        if (menu.id === 10) navigate('/inventario');
        if (menu.id === 11) navigate('/formacion');
        if (menu.id === 12) navigate('/soporte/mis-tickets');
      }}
      className={numbtn === menu.id ? 'active' : ''}
    >
      <CustomTooltip mensaje={menu.name} alineado="left" tamano="1.0rem">
        <div>
          <menu.icon className="sidebarIcons" />
        </div>
      </CustomTooltip>
    </li>
  );

  return (
    <>
      <div
        id="mySidebar"
        className={sidebarClass}
        style={{
          width: props.isMobile ? "100%" : props.sidebar ? "230px" : "100px",
          height: props.isMobile && !props.isOpen ? "95px" : props.isMobile ? "auto" : "100vh",
          paddingLeft: 0,
          overflowX: 'hidden',
          overflowY: props.isMobile ? 'auto' : 'visible',
          maxHeight: props.isMobile ? '100vh' : 'none'
        }}
      >
        {props.isMobile ? (
          <div className="header flex items-center justify-between">
            <div className="flex items-center">
              <Hamburger toggled={props.isOpen} toggle={props.setOpen} size={24} />
            </div>
            <Link to="/panel-inicio">
              <img
                src={logoSrc}
                className={`clasesLogo ${props.sidebar ? "expanded" : "collapsed"} block cursor-pointer`}
                style={logoStyle}
                alt="CURSOS"
              />
            </Link>
            <div>
              <UserMenu isMobile={props.isMobile} setAutenticado={props.setAutenticado} />
            </div>
          </div>
        ) : (
          <div className="header">
            <Link to="/panel-inicio">
              <img
                src={logoSrc}
                className={`clasesLogo ${props.sidebar ? "expanded" : "collapsed"} cursor-pointer`}
                style={logoStyle}
                alt="CURSOS"
              />
            </Link>
          </div>
        )}

        {(props.isOpen || !props.isMobile) && (
          <div className="menu-content">
            <div className="lista-principal">
              <div className="mt-5"></div>
              <ul>
                {menusArriba.map(renderRailItem)}
              </ul>
              {itemConfig && (
                <ul className="lista-config">
                  {renderRailItem(itemConfig)}
                </ul>
              )}
            </div>

            <div className="lista lista-secundaria mt-5">
              {numbtn === 0 && (
                <ul>
                  <MenuConvocatoria convocatoria="true" showSidebar={props.isMobile ? true : props.sidebar} rol={rol} />
                </ul>
              )}
              {numbtn === 1 && (
                <ul>
                  <MenuBonificada showSidebar={props.isMobile ? true : props.sidebar} rol={rol} />
                </ul>
              )}
              {numbtn === 2 && (
                <ul>
                  <MenuPersonas showSidebar={props.isMobile ? true : props.sidebar} rol={rol} />
                </ul>
              )}
              {numbtn === 3 && (
                <ul>
                  <MenuWiki showSidebar={props.isMobile ? true : props.sidebar} rol={rol} />
                </ul>
              )}
              {numbtn === 4 && (
                <ul>
                  <MenuInventario showSidebar={props.isMobile ? true : props.sidebar} rol={rol} />
                </ul>
              )}
              {numbtn === 5 && (
                <ul>
                  <MenuVacaciones showSidebar={props.isMobile ? true : props.sidebar} rol={rol} esColaborador={esColaborador} />
                </ul>
              )}
              {numbtn === 6 && (
                <ul>
                  <MenuComunicacion showSidebar={props.isMobile ? true : props.sidebar} rol={rol} esSupervisor={esSupervisor} />
                </ul>
              )}
              {numbtn === 7 && (
                <ul>
                  <MenuEstadisticas showSidebar={props.isMobile ? true : props.sidebar} tienePermiso={tienePermiso} />
                </ul>
              )}
              {numbtn === 8 && (
                <ul>
                  <MenuConfiguracion showSidebar={props.isMobile ? true : props.sidebar} rol={rol} />
                </ul>
              )}
              {numbtn === 9 && (
                <ul>
                  <MenuGestorIntervenciones showSidebar={props.isMobile ? true : props.sidebar} rol={rol} />
                </ul>
              )}
              {numbtn === 10 && (
                <ul>
                  <InventarioSidebar showSidebar={props.isMobile ? true : props.sidebar} />
                </ul>
              )}
              {numbtn === 11 && (
                <ul>
                  <FormacionSidebar showSidebar={props.isMobile ? true : props.sidebar} />
                </ul>
              )}
              {numbtn === 12 && (
                <ul>
                  <SoporteSidebar showSidebar={props.isMobile ? true : props.sidebar} />
                </ul>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;